// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {validAmountOfUse} from '../../shared/services/claim-shared-helper';

export const updateFailedModeDropDown = (key, collection) => ({
    collection,
    key,
    property: 'failureMode',
    type: actions.UPDATE_CLAIM_TRACK_FAILED_MODE
});

export const updateTrackClaimPartSerialNumber = value => ({
    property: 'failurePartSerialNumber',
    type: actions.UPDATE_CLAIM_TRACK_PART_SERIAL_NUMBER,
    value
});

export const updateTrackClaimFailedModeComments = value => ({
    property: 'failureModeComments',
    type: actions.UPDATE_CLAIM_TRACK_FAILED_MODE_COMMENTS,
    value
});

export const updateTrackClaimDtacCase = value => ({
    property: 'dtacCase',
    type: actions.UPDATE_CLAIM_TRACK_DTAC_CASE,
    value
});

export const updateTrackClaimDtacSolution = value => ({
    property: 'dtacSolution',
    type: actions.UPDATE_CLAIM_TRACK_DTAC_SOLUTION,
    value
});

export const updateTrackClaimOperatorsComplaint = value => ({
    property: 'operatorsComplaint',
    type: actions.UPDATE_CLAIM_TRACK_OPERATORS_COMPLAINT,
    value
});

export const updateTrackClaimComplaintCause = value => ({
    property: 'causeOfComplaining',
    type: actions.UPDATE_CLAIM_TRACK_COMPLAINT_CAUSE,
    value
});

export const updateTrackClaimComplaintCorrection = value => ({
    property: 'howWasComplaintCorrected',
    type: actions.UPDATE_CLAIM_TRACK_COMPLAINT_CORRECTION,
    value
});

export const updateTrackClaimOperatorComments = value => ({
    property: 'comments',
    type: actions.UPDATE_CLAIM_TRACK_OPERATORS_COMMENTS,
    value
});

export const updateTrackClaimBasisForSettlement = value => ({
    property: 'basisForSettlement',
    type: actions.UPDATE_CLAIM_TRACK_BASIS_FOR_SETTLEMENT,
    value
});

export const updateTrackClaimLugHeightUnits = (key, unitCollection) => ({
    key,
    type: actions.UPDATE_CLAIM_TRACK_LUGHEIGHT_UNIT,
    unitCollection
});

export const updateTrackClaimAverageLugHeightAmount = amount => ({
    amount,
    type: actions.UPDATE_CLAIM_TRACK_LUGHEIGHT
});

export const updateTrackClaimPartsUseUnits = (key, unitCollection) => ({
    key,
    type: actions.UPDATE_CLAIM_TRACK_PARTS_USE_UNIT,
    unitCollection
});

export const updateTrackClaimPartsUseAmount = amount => ({
    amount: validAmountOfUse(amount),
    type: actions.UPDATE_CLAIM_TRACK_PARTS_USE
});



// WEBPACK FOOTER //
// ./src/claim/track/action-creators/failure-panel.js